export const ANIMATION_DURATION = {
  instant: '0.075s',
  fast:    '0.15s',
  normal:  '0.3s',
  slow:    '1.5s',
};

export const TRANSITIONS = {
  clickable: 'background 0.1s ease',
  standard:  'all 0.15s ease',
  color:     'color 0.15s ease, background-color 0.15s ease',
  transform: 'transform 0.2s ease',
};
